import { PostListItem } from './PostListItem';

import type { Post } from '@/types';

interface Props {
  posts: Post[];
}

export const PostList = ({ posts }: Props) => {
  return (
    <div className="mx-auto prose">
      {posts.map((post) => (
        <PostListItem post={post} key={post._id} />
      ))}
    </div>
  );
};
